<div fxFlex fxLayoutAlign="center" fxLayout="column" class="content-container">
	<h1>403</h1>
	<h2>{{ 'errors.access-denied' | translate }}</h2>
	<p>
		<a [routerLink]="['/']">{{ 'shared.actions.back-to-dashboard' | translate }}</a>
	</p>
</div>
